document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab_list li");
    const filmSections = document.querySelectorAll(".data_left .data_in");
    const filmSizeSections = document.querySelectorAll(".film_size .film_size_in");
    const styleSections = document.querySelectorAll(".style_swatches .style_wrapper");
    const styleSwatches = document.querySelectorAll(".style_col");
    const filmLinks = document.querySelectorAll(".filmlink");
    // Hide all sections initially
    filmSections.forEach(section => section.style.display = "none");
    filmSizeSections.forEach(section => section.style.display = "none");
    styleSections.forEach(section => section.style.display = "none");

    // Set the first tab and section as active
    if (tabs.length > 0) {
        tabs[0].querySelector(".size_item").classList.add("active");
        const btnLink = tabs[0]?.getAttribute("data-btnlink");
        filmLinks.forEach(filmlink => {
            if (btnLink && btnLink.trim() !== "") {
                filmlink.setAttribute("href", btnLink);
                filmlink.style.display = "flex";
            } else {
                filmlink.style.display = "none";
            }
        });
        if (filmSections.length > 0) filmSections[0].style.display = "flex";
        if (filmSizeSections.length > 0) filmSizeSections[0].style.display = "block";
        if (styleSections.length > 0) styleSections[0].style.display = "block";
    }

    // Add click event to tabs
    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            // Remove active class from all tabs
            tabs.forEach(t => t.querySelector(".size_item").classList.remove("active"));
            // Add active class to clicked tab
            tab.querySelector(".size_item").classList.add("active");

            // Hide all sections
            filmSections.forEach(section => section.style.display = "none");
            filmSizeSections.forEach(section => section.style.display = "none");
            styleSections.forEach(section => section.style.display = "none");

            // Show the corresponding section
            if (filmSections[index]) filmSections[index].style.display = "flex";
            if (filmSizeSections[index]) filmSizeSections[index].style.display = "block";
            if (styleSections[index]) styleSections[index].style.display = "block";
        const btnLink = tab?.getAttribute("data-btnlink");
        filmLinks.forEach(filmlink => {
            if (btnLink && btnLink.trim() !== "") {
                filmlink.setAttribute("href", btnLink);
                filmlink.style.display = "flex";
            } else {
                filmlink.style.display = "none";
            }
        });
        });
    });
      styleSwatches.forEach(swatch => {
        swatch.addEventListener("click", function () {
            // Remove active_swatch class from all swatches
            styleSwatches.forEach(s => s.classList.remove("active_swatch"));
            // Add active_swatch class to the clicked one
            swatch.classList.add("active_swatch");
            let title = swatch.getAttribute("data-title");
            let filmImage = swatch.dataset.filmimage;
            let styleWrapper = swatch.closest(".style_wrapper"); // Find the closest parent with class style_wrapper
            let filmName = styleWrapper ? styleWrapper.dataset.filmname : null;
    
            if (filmName) {
	let targetContainer = document.querySelector(`.film_size_in.${filmName}`);

	if (targetContainer) {
		let titleElement = targetContainer.querySelector("h4[data-swatchname]");
		if (titleElement) {
			titleElement.textContent = title;
		}

		let imageContainer = targetContainer.querySelector(`.size_img`);
		if (imageContainer) {
			let imageElement = imageContainer.querySelector("img");
			if (imageElement) {
				imageElement.src = filmImage;
                imageElement.srcset = filmImage;
			}
		}
	}
}
            
        });
     });
});
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".style_swatches .style_wrapper").forEach((wrapper, index) => {
        let swiperContainer = wrapper.querySelector(".swiper-container");
        let nextButton = wrapper.querySelector(".swiper-button-next");
        let prevButton = wrapper.querySelector(".swiper-button-prev");

        new Swiper(swiperContainer, {
            loop: false,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            slidesPerView: "auto",
            spaceBetween: 6,
            paginationClickable: true,
            breakpoints: {
                1920: {
                    slidesPerView: "auto",
                },
                1028: {
                    slidesPerView: "auto",
                },
                480: {
                    slidesPerView: "auto",
                }
            }
        });
    });
});